<template>
    <b-row>
        <b-col :xl="12">
            <b-card-text class="mb-1 text-left">
                <b-link @click="toPrevMonth" v-if="hasPrevMonth">
                    <i class="fas fa-angle-left"></i>
                </b-link>
                {{ selectedMonth }}
                <b-link @click="toNextMonth" v-if="hasNextMonth">
                    <i class="fas fa-angle-right"></i>
                </b-link>
                <b-link class="float-right" @click="toLatestMonth" v-if="hasNextMonth">
                    <i class="fas fa-angle-double-right"></i>
                </b-link>
            </b-card-text>
            <template v-if="(status === 'success' && !isNoContent) || editMode">
                <h2 class="text-right text-nowrap text-primary">
                    {{ $_getDollar(data.cost) }}
                </h2>
                <div>
                    <b-card-text class="text-right mb-0" v-if="data.estimatedCost">
                        <small>
                            ~ {{ data.date.substring(2, 7) }}
                        </small>
                    </b-card-text>
                    <b-card-text class="text-right mb-0" v-if="data.lastMonthCost && !data.estimatedCost">
                        <small>
                            {{ monthIncreaseRate }}%
                            <span v-if="data.lastMonthCost < data.cost">
                                ▲
                            </span>
                            <span v-if="data.lastMonthCost > data.cost">
                                ▼
                            </span>
                            {{ $t('org.billing.Compared to previous month')}}
                        </small>
                    </b-card-text>
                </div>
                <hr>
            </template>
        </b-col>
        <b-col
            :xl="12"
            class="mt-2"
        >
            <div v-if="(!isNoContent && estimatable) || editMode">
                <h6>
                    {{ $t('org.billing.Estimated Cost') }}
                </h6>
                <h2 class="text-right text-nowrap text-primary">
                    {{ $_getDollar(data.estimatedCost) }}
                </h2>
                <b-card-text class="mb-0 text-right" v-if="data.lastMonthCost">
                    <small class="text-nowrap">
                        {{ Math.round(Math.abs(data.estimatedIncreasedRate || 0)) }}%
                        <span v-if="data.lastMonthCost < data.estimatedCost">▲</span>
                        <span v-if="data.lastMonthCost > data.estimatedCost">▼</span>
                    </small>
                    <br>
                    <small>
                        {{ $t('org.billing.Compared to previous month')}}
                    </small>
                </b-card-text>
            </div>
            <b-card-text v-if="data.lastMonthCost && !data.estimatedCost">
                {{ $t('org.billing.Previous Month') }} <span class="float-right"> {{$_getDollar(data.lastMonthCost).replace(' ','')}}</span>
                <div class="clearfix"></div>
            </b-card-text>
        </b-col>
    </b-row>
</template>
<script>
import useCommonData from '@/composables/useCommonData'
import useSelectMonth from '@/composables/useSelectMonth'
import useDashboard from '@/composables/useDashboard'
import { computed, getCurrentInstance, watch } from '@vue/composition-api'
export default {
    props: ['isNoContent', 'editMode'],
    setup (props, context) {
        const vm = getCurrentInstance().proxy
        const store = vm.$store
        const currentParams = computed(() => store.getters['$_dashboard/currentParams'])

        const { __getMonthShortString } = useCommonData()
        const { getTotalCost } = useDashboard()
        const { monthOptions, selectedMonth, handleSelectMonth, estimatable } = useSelectMonth()
        const [status, data] = getTotalCost(currentParams.value)

        const years = computed(() => {
            return monthOptions.value.map(month => month.substring(0, 4)).filter((obj, pos, arr) => {
                return arr.indexOf(obj) === pos
            })
        })
        const monthIncreaseRate = computed(() => (Math.round(Math.abs((data.value.lastMonthCost - data.value.cost) / data.value.lastMonthCost) * 1000) / 10) || 0)
        const maxMonthCost = computed(() => monthOptions.value.length ? Math.max.apply(null, monthOptions.value.map(item => item.cost)) : 0)
        const monthIndex = computed(() => {
            return monthOptions.value.indexOf(selectedMonth.value)
        })
        const hasNextMonth = computed(() => monthIndex.value > 0)
        const hasPrevMonth = computed(() => monthIndex.value < monthOptions.value.length - 1)

        // /** method */
        const toPrevMonth = () => handleSelectMonth(monthOptions.value[monthIndex.value + 1])
        const toNextMonth = () => handleSelectMonth(monthOptions.value[monthIndex.value - 1])
        const toLatestMonth = () => handleSelectMonth(monthOptions.value[0])
        const changeMonth = (month) => handleSelectMonth(month)
        watch(currentParams, (value, oldValue) => {
            getTotalCost(value)
        }, {
            deep: true
        })
        return {
            monthIncreaseRate,
            estimatable,
            status,
            data,
            selectedMonth,
            __getMonthShortString,
            years,
            maxMonthCost,
            hasNextMonth,
            hasPrevMonth,
            toPrevMonth,
            toNextMonth,
            toLatestMonth,
            changeMonth
        }
    }
}
</script>

<style>

</style>
